import Auth from '../api/auth';
import { clearCookiesOnLogout } from '../store/utils/api';

const parseErrorCode = error => {
  // Backend responde 401 com code quando o acesso caiu: fora da janela de
  // horario (business_hours_closed) ou agente INATIVO/saiu da empresa
  // (user_inactive). Desloga o usuario na hora (limpa cookies e redireciona).
  const logoutCodes = ['business_hours_closed', 'user_inactive'];
  if (
    error?.response?.status === 401 &&
    logoutCodes.includes(error?.response?.data?.code)
  ) {
    clearCookiesOnLogout();
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.segueConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
